import { Breakpoints, Container } from '@volkswagen-onehub/components-core';
import { useScroll } from 'framer-motion';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { VipsBackground } from './components/vips-background';
import { VipsContent } from './components/vips-content';

const VipsSection = styled.section`
	position: relative;
	width: 100vw;
	height: 100%;
	max-width: 100%;
	overflow: hidden;
`;

export const Vips = (): React.ReactElement => {
	const vipsRef = useRef<HTMLElement | null>(null);

	const { scrollYProgress } = useScroll({
		target: vipsRef,
		offset: ['start end', 'end start'],
	});

	return (
		<VipsSection className="vips-section" ref={vipsRef}>
			<VipsBackground />
			<Container
				data-testid="vips-section__content"
				wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b1280]: 'never' }}
			>
				<VipsContent progress={scrollYProgress} />
			</Container>
		</VipsSection>
	);
};
